import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Logo, GradientBar, Card, Badge, Button, LoadingState, ErrorState } from "@/components/design-system";
import { publicProfile } from "@/lib/ambassadors";
import { formatApiError } from "@/lib/api";

export default function AmbassadorPublicProfile() {
  const { slug } = useParams();
  const [state, setState] = useState({ status: "loading", p: null, err: "" });
  useEffect(() => {
    (async () => {
      try { const p = await publicProfile(slug); setState({ status: "ready", p, err: "" }); document.title = `${p.name} — Verified Ambassador · SaaSLaunchingLab`; }
      catch (err) { const s = err?.response?.status; setState({ status: s === 404 ? "notfound" : "error", p: null, err: formatApiError(err) }); }
    })();
  }, [slug]);

  return (
    <div className="min-h-screen bg-white text-[#0B1F3A]">
      <header className="border-b border-[#0B1F3A]/10">
        <div className="max-w-4xl mx-auto px-6 h-20 flex items-center justify-between">
          <Link to="/"><Logo variant="light" height={54} /></Link>
          <Link to="/register?role=community"><Button variant="primary">Join community</Button></Link>
        </div>
        <GradientBar />
      </header>
      <main className="max-w-4xl mx-auto px-6 py-14">
        {state.status === "loading" && <LoadingState />}
        {state.status === "notfound" && <div className="text-center py-16"><h1 className="font-[Montserrat] font-extrabold text-3xl">Ambassador not found.</h1></div>}
        {state.status === "error" && <ErrorState detail={state.err} />}
        {state.status === "ready" && state.p && (
          <>
            <Badge variant="ambassador">Verified ambassador · SaaSLaunchingLab</Badge>
            <h1 data-testid="public-ambassador-name" className="font-[Montserrat] font-extrabold text-5xl mt-3 tracking-tighter">{state.p.name}</h1>
            <p className="mt-3 text-[#0B1F3A]/70">Verified {new Date(state.p.verified_at).toLocaleDateString()} · {state.p.points} reputation points · {state.p.tier}</p>
            <div className="mt-8 grid grid-cols-3 gap-4">
              <Card className="!p-5 text-center"><div className="font-[Montserrat] font-extrabold text-3xl">{state.p.stats.submissions}</div><div className="text-[10px] uppercase tracking-widest text-[#0B1F3A]/60 mt-1">feedback given</div></Card>
              <Card className="!p-5 text-center"><div className="font-[Montserrat] font-extrabold text-3xl">{state.p.stats.marked_helpful}</div><div className="text-[10px] uppercase tracking-widest text-[#0B1F3A]/60 mt-1">marked helpful</div></Card>
              <Card className="!p-5 text-center"><div className="font-[Montserrat] font-extrabold text-3xl">{state.p.stats.cited_in_reports}</div><div className="text-[10px] uppercase tracking-widest text-[#0B1F3A]/60 mt-1">cited in feedback reports</div></Card>
            </div>
            {state.p.motivation && (<Card className="mt-6"><h2 className="font-[Montserrat] font-bold text-xl">Why they're here</h2><p data-testid="public-ambassador-motivation" className="mt-2 text-[#0B1F3A]/85 whitespace-pre-wrap">{state.p.motivation}</p></Card>)}
            {state.p.audience && (<Card className="mt-4"><h2 className="font-[Montserrat] font-bold text-xl">Audience</h2><p className="mt-2 text-[#0B1F3A]/85">{state.p.audience}</p></Card>)}
            {state.p.links?.length > 0 && (<div className="mt-6 flex flex-wrap gap-2">{state.p.links.map((l) => <a key={l} className="text-[#2D7FF9] font-semibold hover:underline" href={l} target="_blank" rel="noreferrer">{l}</a>)}</div>)}
          </>
        )}
      </main>
      <footer className="bg-[#0B1F3A] text-white mt-16"><GradientBar /><div className="max-w-4xl mx-auto px-6 py-8 text-xs text-white/60 flex items-center justify-between"><Logo variant="dark" height={40}/><span>© {new Date().getFullYear()} Pastoria Project SL · EU · GDPR-first</span></div></footer>
    </div>
  );
}
